import { ENGLISH_SPEAKING_LOCALES } from '../constants'

export function isEnglishSpeakingLocale(locale: string) {
  return ENGLISH_SPEAKING_LOCALES.includes(locale)
}
